import { IProduct } from "records/item/item";
import { ShipmentStatus } from "constants/shipments";
import { IPromotions } from "./order-pricing";
import { AllocationType } from "types/cart";
import { ICustomizationTemplate } from "./product-customizations/customization";
import { TCustomizationSelection } from "./product-customizations/customization-selection.types";
import { IProductCustomizationSettings } from "records/brand/brand";

export interface IV3Order {
    _id: string;
    __modified_on: string;
    __ship_start: string;
    __order_number: string;
    __total: string;
    __status: string;
    __brand: { __ref: string };
    __brand_name: string;
    __customer_po_number: string;
    __currency_code: string;
    __line_items: ILineItem[];

    __company: {
        __ref?: string;
        __name?: string;
    };
    __cancelled_total?: number;
    __cancelled_units?: number;
    __promotions: IPromotions;
    __product_customization_templates: ICustomizationTemplate[];
    __product_customization_settings: Pick<IProductCustomizationSettings, "prints">;
}

export interface ILineItemSize {
    _id: string;
    size: string;
    size_group: string;
    quantity: number;
    price: number;
    original_price?: number;
    wholesale?: number;
    adjusted_wholesale?: number;
    discounted_price?: number;
    warehouse?: string;
    location?: string;
    __weight?: number;
    __units_per_pack?: number;
}

export interface ILineItem {
    _id: string;
    product: string;
    ship_start: string;
    ship_end: string;
    total_quantity: number;
    total: number;
    price: number;
    originalPrice: number;
    __images: string[];
    __item?: IProduct;
    cancelled?: boolean;
    __shipment_status: ShipmentStatus[];
    sizes: ILineItemSize[];
    warehouse?: string;
    discount?: number;
    allocated?: AllocationType;
    wholesale_string?: string;
    adjusted_wholesale_string?: string;
    retail_string?: string;
    price_override?: number;
    prebook?: boolean;
    __customizations?: TCustomizationSelection[];
    __product_customizations_template_id?: string;
    proof_of_product_id?: string;
    [fdmAttribute: string]: any;
}

export enum IPOSStatus {
    SENT = "sent",
    STARTED = "started",
    PENDING = "pending",
    SUCCESS = "success",
    ERROR = "failure",
    NOT_EXPORTED = "not exported",
}

export enum FLOW_TYPE {
    immediate = "immediate",
    prebook = "prebook",
}

export enum OrderStatus {
    DRAFT = "draft",
    EZ = "ezorder",
}
